export default __webpack_public_path__ + "static/media/012_photo.53782626.jpg";